import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@helix/platform/shared/api';
import { DataPage, RX_DEFINITION } from '@helix/platform/shared/api';
import * as i2 from '@angular/common/http';
import { of } from 'rxjs';

class RxeventStatisticsDefinitionDataPageService extends DataPage {
    constructor(injector) {
        super(injector, 'com.bmc.arsys.rx.application.event.datapage.EventStatisticsDefinitionDataPageQuery');
        this.injector = injector;
    }
}
RxeventStatisticsDefinitionDataPageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxeventStatisticsDefinitionDataPageService, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
RxeventStatisticsDefinitionDataPageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxeventStatisticsDefinitionDataPageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxeventStatisticsDefinitionDataPageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; } });

class RxEventStatisticsDefinitionService {
    constructor(rxCommandFactoryService, httpClient) {
        this.rxCommandFactoryService = rxCommandFactoryService;
        this.httpClient = httpClient;
        this.url = '/api/rx/application/event/eventstatisticsdefinition';
    }
    revertCustomization(eventStatisticsDefinitionName) {
        const revertCustomizationCommand = this.rxCommandFactoryService.forResourceType('com.bmc.arsys.rx.application.event.command.RevertEventStatisticsDefinitionCommand');
        return revertCustomizationCommand.execute({ eventStatisticsDefinitionName });
    }
    get(eventDefinitionName, options) {
        return this.httpClient.get(`${this.url}/${encodeURIComponent(eventDefinitionName)}`, options);
    }
    getNew() {
        return of({
            eventName: null,
            description: null,
            guid: null,
            groupByKeys: [],
            frequencies: [],
            eventStatisticsOperations: [],
            allowOverlay: false,
            isEnabled: true,
            shouldGetCount: true,
            scope: RX_DEFINITION.scopes.bundle,
            overlayDescriptor: null
        });
    }
    update(eventDefinitionName, eventDefinition) {
        return this.httpClient.put(`${this.url}/${encodeURIComponent(eventDefinitionName)}`, eventDefinition);
    }
    create(eventDefinition) {
        return this.httpClient.post(this.url, eventDefinition);
    }
}
RxEventStatisticsDefinitionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventStatisticsDefinitionService, deps: [{ token: i1.RxCommandFactoryService }, { token: i2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
RxEventStatisticsDefinitionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventStatisticsDefinitionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RxEventStatisticsDefinitionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.RxCommandFactoryService }, { type: i2.HttpClient }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { RxEventStatisticsDefinitionService, RxeventStatisticsDefinitionDataPageService };
